import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fulfilledThunkState, initialThunkState, rejectedThunkState, THUNK_STATUS } from "@duosoftbg/nacid-components";
import { filterARUniEntryRequests } from "../../../../axios/api/services";

const initialState = {
  filter: {},
  list: initialThunkState([]),
};

export const filterArUniEntryRequests = createAsyncThunk(
  `filterArUniEntryRequests/fetchStatus`,
  async (filter: any) => {
    const response = await filterARUniEntryRequests(filter)();
    return response;
  },
);

const arUniEntryRequestsListSlice = createSlice({
  name: "ARUniEntryRequestsListSlice",
  initialState: initialState,
  reducers: {
    setFilter: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(filterArUniEntryRequests.fulfilled, (state, action) => {
      state.list = fulfilledThunkState(action.payload);
    });
    builder.addCase(filterArUniEntryRequests.pending, (state, action) => {
      state.list.status = THUNK_STATUS.PENDING;
    });
    builder.addCase(filterArUniEntryRequests.rejected, (state, action) => {
      state.list = rejectedThunkState([]);
    });
  },
});

export const { setFilter } = arUniEntryRequestsListSlice.actions;
export default arUniEntryRequestsListSlice.reducer;
